<template>
  <div class="px-2 pt-2">
    <v-select
      v-model="currentOption"
      :items="options"
      item-text="label"
      item-value="value"
      :label="$t('changeOddsConfigurationTooltip')"
      dense
      filled
      hide-details
      solo-inverted
      @change="handleOddsChangesChange"
    ></v-select>
  </div>  
</template>

<script>
  export default {
    name: "oddsChangesSettings",
    data: (self) => ({
      currentOption: null,
      options: [
        {
          label: self.$t("acceptAnyOddsChanges"),
          value: "both"
        },
        {
          label: self.$t("acceptAboveOddsChanges"), 
          value: "above"
        },
        {
          label: self.$t("doNotAcceptOddsChanges"), 
          value: "none"
        },
      ],
      showOptions: false,
      userId: 0,
    }),
    mounted() {
      this.userId = this.$store.state.userId;
      const storageOption = localStorage.getItem(`oddsChangesPreference${this.userId}`);

      if (storageOption) {
        this.currentOption = storageOption;
        this.$emit("acceptOddsChangesUpdated", storageOption);
      }
    },
    methods: {
      handleOddsChangesChange(value) {
        localStorage.setItem(`oddsChangesPreference${this.userId}`, value);
        this.$emit("acceptOddsChangesUpdated", value);
      },
    },
  }
</script>
<style scoped>
.v-select {
  font-size: 0.89rem;
}
</style>